/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_No_NumberInputs */

const en_messages_no_number = /** @type {(inputs: Messages_No_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no number`)
};

const he_messages_no_number = /** @type {(inputs: Messages_No_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין מספר`)
};

/**
* | output |
* | --- |
* | "no number" |
*
* @param {Messages_No_NumberInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_no_number = /** @type {((inputs?: Messages_No_NumberInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_No_NumberInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_no_number(inputs)
	return he_messages_no_number(inputs)
});